



























import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator';
import { BaseInputBox } from '../base-input-box';

@Component({
  name: 'BaseTextarea',
  inheritAttrs: false,
  components: {
    BaseInputBox,
  },
})
export default class BaseTextarea extends Vue {
  @Prop() label: string;
  @Prop({ default: false }) resizeable: boolean;
  @Prop() id: string;
  @Prop({ default: '' }) value: string;
  @Prop({ default: false }) success: boolean;
  @Prop({ default: '' }) helpMessage: string;
  @Prop({ default: '' }) errorMessage: string;
  @Prop({ default: false }) error: boolean;
  @Prop() disabled: boolean;
  @Prop({ default: 4 }) rows: number;
  @Prop({ default: false }) fixedLabel: boolean;
  @Ref('textarea') textareaElement: HTMLTextAreaElement;
  @Prop({ default: false }) placeholderAsDefault: boolean;
  @Prop() placeholder: string;

  lazyValue: string = null;
  focused = false;

  @Watch('value')
  watchValue(newValue: string) {
    this.lazyValue = newValue;
  }

  get textareaId(): string {
    return this.id || `textarea-${this['_uid']}`;
  }

  get listeners(): Record<string, (arg?) => void | ((arg?) => void)[]> {
    return {
      ...this.$listeners,
      input: this.handleInput,
      focus: this.handleFocus,
      blur: this.handleBlur,
    };
  }

  get active(): boolean {
    return this.focused || !!this.lazyValue || this.fixedLabel;
  }

  handleFocus() {
    if (this.placeholderAsDefault && !this.value) {
      this.$emit('input', this.placeholder);
    }
    this.focused = true;
    this.$emit('focus');
  }

  handleBlur(event: Event) {
    if (this.placeholderAsDefault && this.value === this.placeholder) {
      this.$emit('input', '');
    }
    this.focused = false;
    this.$emit('blur', event);
  }

  handleInput(event) {
    this.lazyValue = event.target.value;
    this.$emit('input', event.target.value);
  }

  focus() {
    this.textareaElement.focus();
  }

  created() {
    this.lazyValue = this.value;
  }
}
